module.exports = __webpack_public_path__ + "static/media/Big Time.d238b257.jpg";